import { render } from "./KeepWatchingSection.vue?vue&type=template&id=9128faee&scoped=true"
import script from "./KeepWatchingSection.vue?vue&type=script&lang=js"
export * from "./KeepWatchingSection.vue?vue&type=script&lang=js"

import "./KeepWatchingSection.vue?vue&type=style&index=0&id=9128faee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9128faee"]])

export default __exports__